import Vue from 'vue';

// import Quill from 'quill';
import VueQuillEditor, { Quill } from 'vue-quill-editor';

import './toolbar/link/';
import './toolbar/icons/';
import './toolbar/placeholder/';
import './toolbar/textGeneration/';
import './toolbar/colorPalette/';
import './imageBlocker';

// import './paste';
import 'quill-paste-smart';

// import PasteSmart from './paste';
// Quill.register('modules/clipboard', PasteSmart, true);

// Content loaded into an editor is not an edit: vue-quill-editor pastes it with
// the API source, and undo used to go past the user's edits and empty the
// editor. Every toolbar tool inserts with the USER source, so those stay undoable.
Quill.import('modules/history').DEFAULTS.userOnly = true;

const Parchment = Quill.import('parchment');

let LinkClass = new Parchment.Attributor.Class('link', 'ql-link', {
    scope: Parchment.Scope.INLINE,
    whitelist: ['el-button', 'el-button--info', 'el-button--mini', 'el-button--medium', 'el-button--large']
});

Quill.register(
    {
        'attributors/class/link': LinkClass
    },
    true
);

Vue.use(VueQuillEditor);
